import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { CardPersonalizing, RidangoReduxAction } from '@ridango/core';

import { PersonalizeActions } from './personalize.actions';
import { PersonalizePartialStoreState } from './personalize.reducer';
import * as PersonalizeSelectors from './personalize.selectors';

@Injectable()
export class PersonalizeFacade {
    isPersonalizingFinished$ = this.store.select(PersonalizeSelectors.getPersonalizingFinished);
    error$ = this.store.select(PersonalizeSelectors.getError);
    isPersonalizingLoading$ = this.store.select(PersonalizeSelectors.getPersonalizingLoading);

    constructor(
        private store: NgRedux<PersonalizePartialStoreState>,
        private actions: PersonalizeActions
    ) {}

    private dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    resetPersonalizedState(): void {
        this.dispatch(this.actions.resetPersonalizedState());
    }

    savePersonalizedCardNoIssue(payload: CardPersonalizing) {
        this.dispatch(this.actions.savePersonalizedCardNoIssue(payload));
    }

    savePersonalizedCard(payload: CardPersonalizing) {
        this.dispatch(this.actions.savePersonalizedCard(payload));
    }

    setPersonalizedLoading(loading: boolean) {
        this.dispatch(this.actions.setPersonalizedLoading(loading));
    }
}
